<template>
    <div class="w-full">
        <div class="w-full flex items-end gap-2">
            <custom-input
                id="barcode"
                v-model="barcode"
                label="Código de barras"
                :disabled="!enabled"
                :error="isDuplicated ? 'Código de barras ya registrado' : ''"
                @blur="verifyBarcode"
                @input="inputBarcode"
            />
            <barcode-scanner-button v-if="enabled" @change="change" />
        </div>

        <div>
            <app-dialog v-model="isOpenModal">
                <template #header>
                    <span>
                        Variantes registradas con el código de barras
                        {{ barcode }}
                    </span>
                </template>
                <div class="flex flex-col items-center">
                    <reference-item
                        v-for="reference in references"
                        :key="reference.id"
                        :reference="reference"
                    />
                </div>
            </app-dialog>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

import ReferenceItem from "../references/ReferenceItem.vue";
import BarcodeScannerButton from "./BarcodeScannerButton.vue";

export default {
    name: "BarcodeScannerInput",
    components: { AppDialog, BarcodeScannerButton, CustomInput, ReferenceItem },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        check: {
            type: Boolean,
            required: false,
            default: () => false
        },
        referenceId: {
            type: Number,
            required: false,
            default: () => 0
        },
        itemCurrent: {
            type: String,
            required: true,
            default: () => ""
        }
    },
    data: () => ({
        isDuplicated: false,
        barcode: "",
        isLoading: false,
        references: [],
        isOpenModal: false
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {
        itemCurrent(value) {
            this.barcode = value;
        }
    },
    mounted() {
        this.barcode = String(this.itemCurrent);
    },
    methods: {
        ...mapActions("products", ["listReferenceByBarcode"]),
        change(barcode) {
            if (barcode === this.barcode) {
                return;
            }
            this.barcode = barcode;
            this.$emit("change", this.barcode);
            if (barcode !== "") {
                this.verifyBarcode();
            }
        },
        inputBarcode() {
            this.$emit("change", this.barcode);
        },
        async verifyBarcode() {
            if (this.check && this.barcode) {
                this.isDuplicated = false;
                this.isLoading = true;
                try {
                    this.references = await this.listReferenceByBarcode({
                        barcode: this.barcode
                    });
                    const isDuplicated = this.references.some(
                        (item) => this.referenceId !== item.id
                    );
                    this.isDuplicated = isDuplicated;
                    this.isOpenModal = isDuplicated;
                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    console.error(this.backgroundColor);
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        }
    }
};
</script>
